import { ref } from "vue";
const _locales = {
    NO: "nb-NO",
    EN: "en-GB",
    UA: "uk-UA",
    FI: "fi-FI"
};
export const locales = _locales;
export function useMiscData() {
    const locales = ref(_locales);
    const paradressageGradesMap = ref([
        { id: "1", name: "Grade I" },
        { id: "2", name: "Grade II" },
        { id: "3", name: "Grade III" },
        { id: "4", name: "Grade IV" },
        { id: "5", name: "Grade V" }
    ]);
    return {
        locales,
        paradressageGradesMap
    };
}
